document.addEventListener('DOMContentLoaded', function() {
  // only allow if the extended grid block is on the page, the scroll has a slight performance implication
  if (document.querySelector('.extended-grid')) {

    // get the document scroll event to control page scroll
    document.addEventListener('wheel', function (e) {
      // get the element under the mouse pointer
      const hoverElement = document.elementFromPoint(e.clientX, e.clientY);
      console.log('scroll');

      if (!hoverElement) {
        return;
      }

      // check if the element is part of the extended grid
      let gridElement = hoverElement.closest('.extended-grid');

      if (gridElement === null) {
        return;
      }

      if ((gridElement.scrollLeft + gridElement.clientWidth + 2) < gridElement.scrollWidth && e.deltaY > 0) {
        e.preventDefault();
      }

      if (gridElement.scrollLeft !== 0 && e.deltaY < 0) {
        e.preventDefault();
      }

      if (e.deltaY > 0) {
        gridElement.scrollLeft += 100;
      } else {
        gridElement.scrollLeft -= 100;
      }
    }, {passive: false});
  }
});